(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auyol-collection-intro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', (event) => {
  const row = event.target.closest('.auyol-collection__row');
  if (row) row.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auyol-review-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-auyol-review-slider]';

    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;

      const track = root.querySelector('[data-track]');
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-dot]'));
      const previous = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      const pause = root.querySelector('[data-pause]');
      const status = root.querySelector('[data-status]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayEnabled = root.dataset.autoplay === 'true' && slides.length > 1 && !reducedMotion.matches;
      const speed = Number(root.dataset.speed) || 6000;
      const pauseReasons = new Set();
      let current = 0;
      let timer;
      let scrollTimer;
      let manualPaused = false;

      if (!track || slides.length === 0) return;
      root.dataset.initialized = 'true';

      const statusText = (index) => root.dataset.statusTemplate
        .replace('__current__', String(index + 1))
        .replace('__total__', String(slides.length));

      const setActive = (index, announce = false) => {
        current = (index + slides.length) % slides.length;

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (announce && status) status.textContent = statusText(current);
      };

      const centerSlide = (index, behavior = 'smooth', announce = true) => {
        const target = (index + slides.length) % slides.length;
        const slide = slides[target];
        const left = slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;
        track.scrollTo({ left, behavior });
        setActive(target, announce);
      };

      const stopTimer = () => {
        window.clearTimeout(timer);
        timer = undefined;
      };

      const startTimer = () => {
        stopTimer();
        if (!autoplayEnabled || manualPaused || pauseReasons.size > 0 || document.hidden) return;
        timer = window.setTimeout(() => {
          centerSlide(current + 1);
          startTimer();
        }, speed);
      };

      const setPauseReason = (reason, active) => {
        if (active) {
          pauseReasons.add(reason);
        } else {
          pauseReasons.delete(reason);
        }
        startTimer();
      };

      const updatePauseButton = () => {
        if (!pause) return;
        pause.classList.toggle('is-paused', manualPaused);
        pause.setAttribute('aria-label', manualPaused ? root.dataset.playLabel : root.dataset.pauseLabel);
      };

      const syncFromScroll = () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const center = track.scrollLeft + track.clientWidth / 2;
          let nearest = 0;
          let distance = Number.POSITIVE_INFINITY;

          slides.forEach((slide, index) => {
            const nextDistance = Math.abs(center - (slide.offsetLeft + slide.clientWidth / 2));
            if (nextDistance < distance) {
              distance = nextDistance;
              nearest = index;
            }
          });

          if (nearest !== current) setActive(nearest);
        }, 100);
      };

      previous?.addEventListener('click', () => {
        centerSlide(current - 1);
        startTimer();
      });

      next?.addEventListener('click', () => {
        centerSlide(current + 1);
        startTimer();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          centerSlide(Number(dot.dataset.dot));
          startTimer();
        });
      });

      pause?.addEventListener('click', () => {
        manualPaused = !manualPaused;
        updatePauseButton();
        startTimer();
      });

      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        centerSlide(current + (event.key === 'ArrowRight' ? 1 : -1));
        startTimer();
      });

      track.addEventListener('scroll', syncFromScroll, { passive: true });
      root.addEventListener('pointerenter', () => setPauseReason('pointer', true));
      root.addEventListener('pointerleave', () => setPauseReason('pointer', false));
      root.addEventListener('focusin', () => setPauseReason('focus', true));
      root.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => setPauseReason('focus', root.contains(document.activeElement)));
      });

      document.addEventListener('visibilitychange', () => startTimer());

      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) stopTimer();
        else startTimer();
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          ([entry]) => setPauseReason('offscreen', !entry.isIntersecting),
          { threshold: 0.2 }
        );
        observer.observe(root);
      }

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => centerSlide(current, 'auto', false));
        resizeObserver.observe(track);
      }

      setActive(0);
      updatePauseButton();
      window.requestAnimationFrame(() => {
        centerSlide(0, 'auto', false);
        startTimer();
      });
    };

    const initializeAll = (scope = document) => {
      if (scope.matches?.(selector)) initialize(scope);
      scope.querySelectorAll(selector).forEach(initialize);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
